module.exports = __webpack_public_path__ + "static/media/type-post-normal.521156ed.png";